import React from "react";
import { FileQuestion, Images, Info, Mail, Workflow } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHeader } from "./CmsDocumentComponents.js";
import { useTranslation } from "react-i18next";
import "../../css/cmsDocuments.css";
const items = [
  ["homeSlides", "/home-slides", Images], ["newsletter", "/cms-pages/newsletter", Mail],
  ["howItWorks", "/cms-pages/how-it-works", Workflow], ["about", "/cms-pages/about-us", Info],
  ["faqs", "/cms-pages/faq", FileQuestion],
];
export default function ContentHub() {
  const { t } = useTranslation();
  return <main className="cmsd-page"><PageHeader title={t("cmsContent.hub.title")} description={t("cmsContent.hub.description")} />
    <section className="cmsd-content-grid">{items.map(([key, path, Icon]) => <Link to={path} className="cmsd-content-card" key={key}><span><Icon size={22} /></span><div><h2>{t(`cmsContent.hub.items.${key}.title`)}</h2><p>{t(`cmsContent.hub.items.${key}.description`)}</p></div></Link>)}</section>
  </main>;
}
